import { getValueById } from './ConfigurationDataHelperFunctions';

import { appSettings } from '../settings';

/**
 * Retrieves the short/long sales text for a variable, handling both regular and submodel variables
 * @param {IExtendedConfigureResponse} config - The configuration state containing sales text data
 * @param {string} variableType - The type of variable (e.g., Submodel or regular)
 * @param {string} languageCode - The language code for localization
 * @param {string} featureCode - The feature code identifier
 * @returns {string | null} The short/long sales text value, or null if not found
 */
export function getVariableSalesText(
  salesText: Map<string, Map<string, string>>,
  featureCode?: string
): string | null {
  if (!appSettings.UseShortSalesText) {
    return null;
  }
  return salesText ? (getValueById(salesText, featureCode) ?? null) : null;
}
